export const OrderActions = () => {
    return (
        <div className="flex justify-between items-center pl-3 pb-1">
            <div className="font-medium text-lg text-base-primary">
                Order List
            </div>
        </div>
    )
}